import { reactive, onBeforeMount, watch, ref } from "@vue/composition-api";
import router from "@/router";
import useDate from "@/utils/hooks/useDate";
import useModal from "@/@core/components/base-modal/hooks/useModal";
import useFilterHeaderTable from "@/views/components/filter-header-table/useFilterHeaderTable";
import useReorderTable from "@/views/components/base-table/hooks/useReorderTable";
import useBaseTable from "@/views/components/base-table/hooks/useBaseTable";

export default function useCreateMappingBanner(props) {
  const { resolveDateWithSeperator } = useDate();
  const { openModal, closeModal } = useModal();
  const { searchValue } = useFilterHeaderTable();

  const {
    filters,
    ordering,
    loading,
    pagination,
    fields,
    tableData,
    actionTable,
    onPageChange,
    onFilterEntity,
    onSetValueSearch,
    onSelectFilter,
  } = useBaseTable();

  const {
    currentIdSelect,
    currentIndex,
    keyChange,
    tableModeReorder,
  } = useReorderTable();

  
  const setBannerGroupActionList = reactive({
    edit: {
      label: "Edit",
      value: 1,
      icon: "EditIcon",
      display: true,
    },
    // copy: {
    //   label: "Copy to",
    //   value: 2,
    //   icon: "CopyIcon",
    //   display: true,
    // },
    // move: {
    //   label: "Move to",
    //   value: 3,
    //   icon: "MoveIcon",
    //   display: true,
    // },
    reorder: {
      label: "Reorder",
      value: 4,
      icon: "ReorderIcon",
      display: true,
    },
    delete: {
      label: "Delete",
      value: 5,
      icon: "DeleteIcon",
      display: true,
    },
  });

  const setMappingBannerTable = reactive({
    column: [],
    payload: [],
    filterColumn: [],
    filter: [],
    isCreate: false,
  });

  const modalType = reactive({
    mapping: false,
    copy: false,
    move: false,
    reorder: false,
  });

  const indexReorder = ref(null);

  const handleTableReorder = () => {
    setBannerGroupActionList.reorder.display = !setBannerGroupActionList.reorder
      .display;
    tableModeReorder.value = !tableModeReorder.value;
    sortableRowOptions.value.disabled = !tableModeReorder.value;
  };

  const arrayMove = (arr, old_index, new_index) => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  const handleRowChange = async (e) => {
    const arrTemp = setMappingBannerTable.payload;
    const arr = await arrayMove(
      arrTemp,
      e.oldDraggableIndex,
      e.newDraggableIndex
    );
    keyChange.value++;
    setMappingBannerTable.payload = arr;
  };

  const sortableRowOptions = ref({
    chosenClass: "is-selected",
    ghostClass: "sortable-ghost",
    onEnd: handleRowChange,
    disabled: true,
    animation: 300,
    easing: "cubic-bezier(0.22, 1, 0.36, 1)",
  });


  const resolveBannerAction = (type, banner) => {
    switch (type) {
      case 1:
        editBanner(banner.item);
        break;
      // case 2:
      //   modalType.copy = true;
      //   modalConfig.bannerId = banner.item.banner_id;

      //   openModal();
      //   break;
      // case 3:
      //   modalType.move = true;
      //   modalConfig.bannerId = banner.item.banner_id;

      //   openModal();
      //   break;
      case 4:
        modalType.reorder = true;
        openReorderModal(banner.index);
        break;
      case 5:
        resolveDeleteAction(banner.item);
        break;
      default:
        break;
    }
  };

  const resolveCloseModalAction = (type, data) => {
    switch (type) {
      case setBannerGroupActionList.copy:
        break;
      case setBannerGroupActionList.move:
        setMappingBannerTable.payload = JSON.parse(JSON.stringify(data));
        break;
      case setBannerGroupActionList.reorder:
        break;
    }

    closeModal();

    setTimeout(() => {
      modalType.copy = false;
      modalType.move = false;
      modalType.reorder = false;
    }, 500);
  };

  const openReorderModal = (index) => {
    modalType.reorder = true;
    indexReorder.value = index + 1;
    openModal();
  };

  const reorderArray = (arr, old_index, new_index) => {
    if (new_index >= arr.length || new_index < 0) {
      openErrorModal(
        "ทำรายการไม่สำเร็จ",
        `กรุณากรอกตัวเลขระหว่าง 1 - ${arr.length}`
      );
      return arr;
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  const reorderBanner = async (currentIndex, newIndex) => {
    reorderArray(setMappingBannerTable.payload, currentIndex - 1, newIndex - 1);

    keyChange.value++;
    closeModal();
  };

  fields.value = [
    { key: "no", label: "No." },
    { key: "banner_image_url", label: "Image", sortable: true },
    { key: "set_name", label: "Banner Set" },
    { key: "banner_name", label: "Banner Name" },
    { key: "call_to_action", label: "Call to Action" },
    { key: "valid_from", label: "Valid From" },
    { key: "valid_through", label: "Valid Through", sortable: true },
    { key: "latest_update", label: "Latest Update" },
    { key: "status", label: "Status", sortable: true },
    { key: "actions", label: "" },
  ];

  const resolveBannerStatusLabel = (status) => {
    switch (status) {
      case true:
        return "Active";
      case false:
        return "Inactive";

      default:
        return "Unknown";
    }
  };

  const openMappingModal = () => {
    modalType.mapping = true;
    openModal();
  };

  const closeMappingModal = (mappingBannerList) => {
    modalType.mapping = false;
    setMappingBannerTable.payload = mappingBannerList;
    pagination.totalRows = setMappingBannerTable.payload.length;
    pagination.rows = setMappingBannerTable.payload.length;

    closeModal();
  };

  const onSearch = (searchInput) => {
    searchValue.query = searchInput;
  };

  const initMappingBanner = (mappingBanner) => {
    setMappingBannerTable.payload = mappingBanner;
    pagination.totalRows = setMappingBannerTable.payload.length;
    pagination.rows = setMappingBannerTable.payload.length;
  };

  const resolveDeleteAction = (banner) => {
    if (banner.banner_id) {
      return (setMappingBannerTable.payload = setMappingBannerTable.payload.filter(
        (mappedBanner) => mappedBanner.banner_id !== banner.banner_id
      ));
    }

    return (setMappingBannerTable.payload = setMappingBannerTable.payload.filter(
      (mappedBanner) => mappedBanner.set_banner_id !== banner.set_banner_id
    ));
  };

  const editBanner = (banner) => {
    const params = router.currentRoute.params;

    if (banner.set_banner_id) {
      return router.push(
        `/banner/group/${params.ref}/${params.id}/info/set/${banner.set_banner_id}/info`
      );
    }

    if (banner.banner_id) {
      return router.push(
        `/banner/group/${params.ref}/${params.id}/info/banner/info/${banner.banner_id}`
      );
    }
  };

  onBeforeMount(() => {
    initMappingBanner(JSON.parse(JSON.stringify(props.mappingBanner)));
  });

  watch(
    () => props.mappingBanner,
    (newVal, oldVal) => {
      initMappingBanner(JSON.parse(JSON.stringify(newVal)));
    },
    { deep: true }
  );

  watch(
    () => searchValue.query,
    (newVal, oldVal) => {
      pagination.currentPage = 1;
    },
    { deep: true }
  );

  return {
    fields,
    setMappingBannerTable,
    pagination,
    searchValue,
    resolveDateWithSeperator,
    resolveBannerStatusLabel,
    resolveBannerAction,
    closeMappingModal,
    openMappingModal,
    onPageChange,
    onSearch,
    resolveDeleteAction,
    setBannerGroupActionList,
    tableModeReorder,
    handleTableReorder,
    resolveCloseModalAction,
    modalType,
    indexReorder,
    reorderBanner,
    onFilterEntity,
    sortableRowOptions,
    keyChange,
  };
}
